import { render, staticRenderFns } from "./Ownership.vue?vue&type=template&id=28da4640&scoped=true&lang=pug&"
import script from "./Ownership.vue?vue&type=script&lang=js&"
export * from "./Ownership.vue?vue&type=script&lang=js&"
import style0 from "./Ownership.vue?vue&type=style&index=0&id=28da4640&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28da4640",
  null
  
)

export default component.exports